import { ComponentIds } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { removeProducts } from 'rangeConfig/shared/utils/removeProducts';

const removeAllHingedDoorsFromScene = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const doors = coreApi.entities.getByComponent(ComponentIds.DOOR_COMPONENT_ID);

  if (doors.length > 0) {
    removeProducts(doors, coreApi, products);
  }
};

export default removeAllHingedDoorsFromScene;
